import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import InputCustom from "@pages/components/InputCustom";
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import {validateForm} from "../../../../../constants";

export default function VehicleInfoTab({
                                           deal: initialDeal,
                                           initialVehicle = {},
                                           clearMenus,
                                           updateDeal,
                                           dealMileageIntervals = []
                                       }) {
    const [vehicle, setVehicle] = useState({});
    const [deal, setDeal] = useState({});
    const [vehicleInfoIsNotValid, setVehicleInfoIsNotValid] = useState(false)

    useEffect(() => {
        if (initialDeal) {
            setDeal(initialDeal);
        }
    }, [initialDeal]);

    useEffect(() => {
        if (initialVehicle) {
            setVehicle(initialVehicle);
        }
    }, [initialVehicle]);

    useEffect(() => {
        const required = ['stock_no', 'derivative', 'colour']
        setVehicleInfoIsNotValid(!validateForm(required, vehicle));
    }, [vehicle])

    const mileageDone = dealMileageIntervals.length > 0
        ? dealMileageIntervals.map(item => item.total_interval_miles).reduce((a, b) => a + b, 0)
        : 0;

    return (
        <Card>
            <CardHeader>
                <h2>
                    Vehicle information
                    {deal.vehicle_make?.name ? ` : ${deal.vehicle_make.name}` : ""}
                    {deal.vehicle_model?.name ? `, ${deal.vehicle_model.name}` : ""}
                </h2>
            </CardHeader>
            <CardBody>
                <Row>
                    {/* Column 1 */}
                    <Col md={4}>
                        <Col>
                            <InputCustom
                                newLabel="Reg. Number"
                                required
                                checkValid={false}
                                value={vehicle.stock_no || ""}
                                onChange={(e) =>
                                    setVehicle({
                                        ...vehicle,
                                        stock_no: e.target.value,
                                    })
                                }
                            />
                        </Col>
                        <Col>
                            <InputCustom
                                newLabel="Colour"
                                required
                                checkValid={false}
                                value={vehicle.colour || ""}
                                onChange={(e) =>
                                    setVehicle({
                                        ...vehicle,
                                        colour: e.target.value,
                                    })
                                }
                            />
                        </Col>
                        <Col>
                            <InputCustom
                                newLabel="Derivative"
                                required
                                checkValid={false}
                                value={vehicle.derivative || ""}
                                onChange={(e) =>
                                    setVehicle({
                                        ...vehicle,
                                        derivative: e.target.value,
                                    })
                                }
                            />
                        </Col>
                        <Col>
                            <InputCustom
                                newLabel="Current mileage"
                                value={deal.current_mileage || ""}
                                readOnly
                            />
                        </Col>
                    </Col>

                    <Col md={4}>
                        <Col>
                            <InputCustom
                                newLabel="Mileage done since delivery date"
                                value={mileageDone}
                                readOnly
                                disabled
                            />
                        </Col>
                        <Col>
                            <InputCustom
                                type="textarea"
                                label="Extras"
                                rows="5"
                                value={deal.extras || ""}
                                onChange={(e) =>
                                    setDeal({
                                        ...deal,
                                        extras: e.target.value,
                                    })
                                }
                            />
                        </Col>
                    </Col>
                </Row>

                <div className="d-flex flex-row justify-content-end mt-5">
                    <ButtonContainer onClick={clearMenus}>Cancel</ButtonContainer>
                    <ButtonContainer disabled={vehicleInfoIsNotValid} reverse
                                     onClick={() => updateDeal({dealData: deal,vehicleData: vehicle})}>Update</ButtonContainer>
                </div>
            </CardBody>
        </Card>
    );
}
